import styled from 'styled-components';
import { FormControlGroup } from '../../input/FormControlGroup';

export const Wrapper = styled(FormControlGroup)
    .withConfig({ displayName: 'ContentPromotionPostsField' })
    .attrs({
        p: 2,
        borderRadius: 2,
        width: '100%',
        direction: { xs: 'column', sm: 'row' },
        background: 'var(--background-primary)',
    })``;
